/** TermsOfUse — legal document rendered from the shared `legal.termsOfUse` copy. */
import { DocumentIcon } from '../components/ui/icons';
import { LegalContent, type LegalSectionConfig } from '../features/support/LegalContent';

const TERMS_SECTIONS: readonly LegalSectionConfig[] = [
  { key: 'agreement' },
  { key: 'modifications' },
  { key: 'changesToTerms' },
  { key: 'useOfMaterials' },
  { key: 'healthDisclaimer' },
  { key: 'onlineConduct' },
  { key: 'interactiveAreas' },
  { key: 'passwords' },
  { key: 'parentalPermission' },
  { key: 'links' },
  { key: 'choiceOfLaw' },
  { key: 'limitationOfLiability' },
  { key: 'disclaimers', uppercase: true },
];

export function TermsOfUse() {
  return (
    <LegalContent contentKey="termsOfUse" sections={TERMS_SECTIONS} heroIcon={DocumentIcon} />
  );
}
